import React, { FunctionComponent, ReactElement } from "react";

import { BooleanSwitcher, BooleanSwitcherChildrenProps } from "@multiweb/reactComponents";
import { bemClassNames } from "@multiweb/reactUtils";
import { IconCode } from "@multiweb/types/contracts";
import { ActionItemBackgroundContext } from "../../context";
import { ActionItemComponent } from "../ActionItemComponent";

export type ActionMenuProps = {
    /** Jednotlivé prvky rozbaleného menu */
    children: ReactElement | ReactElement[];
    /** Kód rozbalující ikony */
    iconCode?: IconCode;
    /** Příznak, zda je ikona zvýrazněná - využívá se pro zvýraznění ikony při najetí myši na prvek menu */
    isActive?: boolean;
    /** Příznak, zda je zaměřená některá akční položka. */
    isActionItemFocused: boolean;
};

const classNames = bemClassNames("action-menu");

/** Komponenta slouží jako rozbalovací menu u jednotlivých položek menu. */
export const ActionMenu: FunctionComponent<ActionMenuProps> = ({
    children,
    iconCode = IconCode.uiMoreVertical,
    isActive = false,
    isActionItemFocused,
}) => (
    <BooleanSwitcher>
        {({ value: isHovered, turnOn: onMouseEnter, turnOff: onMouseLeave }: BooleanSwitcherChildrenProps) => (
            <div
                className={classNames()}
                onBlur={onMouseLeave}
                onFocus={onMouseEnter}
                /* Řeší situaci po odebrání položky, kdy kvůli pozici myši neproběhne onMouseEnter a menu se tak neotevře. */
                onMouseOver={onMouseEnter}
                {...{ onMouseEnter, onMouseLeave }}
            >
                <ActionItemBackgroundContext.Consumer>
                    {(hasSubmenuBackground) => (
                        <div className={classNames("content", { "submenu-background": hasSubmenuBackground })}>
                            <div className={classNames("highlight", { active: isActive })}>
                                {isHovered || isActionItemFocused ? (
                                    React.Children.map(children, (child: ReactElement) => child && React.cloneElement(child, { isActive, hasSubmenuBackground }))
                                ) : (
                                    <ActionItemComponent
                                        isFocused={false}
                                        {...{ iconCode, isActive, hasSubmenuBackground }}
                                    />
                                )}
                            </div>
                        </div>
                    )}
                </ActionItemBackgroundContext.Consumer>
            </div>
        )}
    </BooleanSwitcher>
);
